
export enum ModuleExecutorDatasetTypeCd {
	CONFIGURATION = 'Configuration',
	MODIFIED_DATA_EXTRACT = 'Modified DataExtract',
	ORIGINAL_DATA_EXTRACT = 'Original DataExtract'}

